import { jsx } from "react/jsx-runtime";
import * as React from "react";
import Logger from "@ane/core/lib/services/logging/Logger";
import { TelemetryEventName } from "@ane/core/lib/services/MSALAuthService/TelemetryEventName";
import { NoContentMessage } from "@ane/ui-components/lib/components/NoContentMessage/NoContentMessage";
import { PrimaryButton } from "@ane/ui-components/lib/components/Button";
import { Stack } from "@ane/ui-components/lib/components/Stack";
import { RegisterIcons, ICON_NAMES } from "../../utils/registerIcons.js";
RegisterIcons();
const SessionExpired = ({ authContext }) => {
  const logIn = () => {
    Logger.trackEvent({
      name: TelemetryEventName.App_SessionExpired_SignInAgain_Click,
      properties: {},
      measurements: {}
    });
    authContext.logIn();
  };
  React.useEffect(() => {
    Logger.trackMetric({ name: TelemetryEventName.App_SessionExpired, properties: {}, average: 0 });
  }, []);
  return /* @__PURE__ */ jsx(
    NoContentMessage,
    {
      iconName: ICON_NAMES.SessionExpired,
      heading: "Session expired",
      description: () => /* @__PURE__ */ jsx("p", { children: "Click Login to refresh your session." }),
      children: /* @__PURE__ */ jsx(Stack, { horizontalAlign: "center", tokens: { childrenGap: 20 }, children: /* @__PURE__ */ jsx(PrimaryButton, { ariaLabel: "Login", role: "link", onClick: logIn, children: "Login" }) })
    }
  );
};
export {
  SessionExpired
};
//# sourceMappingURL=SessionExpired.js.map
